import React, { memo, useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BringgFontIcons } from '@bringg/bringg-icons';
import { TestIds } from 'bringg-web/test-utils/tests.consts';
import { IconButton } from '../../../components';
import { TRANSLATION_DOMAINS } from '../../../consts';

import './batch-dismiss.scss';

const { EXCEPTIONS_LIST: domain } = TRANSLATION_DOMAINS;

interface Props {
	selectedRowIds: Record<string | number, boolean>;
	onDismiss: (rowIds: string[]) => void;
}

function BatchDismiss({ selectedRowIds, onDismiss }: Props) {
	const { t } = useTranslation();
	const rowIds = useMemo(() => Object.keys(selectedRowIds), [selectedRowIds]);
	const { length } = rowIds;

	const onClick = useCallback(() => {
		if (rowIds.length) {
			onDismiss(rowIds);
		}
	}, [onDismiss, rowIds]);
	const translateKey = useMemo(
		() => `${domain}.${length === 1 ? 'ALERT_IS_SELECTED' : 'ALERTS_ARE_SELECTED'}`,
		[length]
	);

	return (
		<div className="exceptions-batch-dismiss">
			{Boolean(rowIds.length) && (
				<IconButton
					icon={BringgFontIcons.Trash}
					data-test-id={TestIds.BATCH_DISMISS_BUTTON}
					className="batch-dismiss-button"
					text={t(`${domain}.DISMISS`)}
					onClick={onClick}
					title={`${length} ${t(translateKey)}`}
				/>
			)}
		</div>
	);
}

export default memo(BatchDismiss) as typeof BatchDismiss;
